import axios from "axios";
import toQueryString from "../common/utils/to-query-string";

const get = (query) => axios.get(toQueryString(`/api/v1/pages?`, query));

const getById = (id, query) => axios.get(toQueryString(`/api/v1/pages/${id}?`, query));

const create = (params) => axios.post(`/api/v1/pages`, params);

const update = (id, params) => axios.put(`/api/v1/pages/${id}`, params);

const remove = (id) => axios.delete(`/api/v1/pages/${id}`);

const removeBulk = (ids) => axios.delete(`/api/v1/pages/bulk`, { data: { ids } });

const fetchIcon = (query) => axios.get(toQueryString(`/api/v1/pages/fetch-icon?`, query));

const getTags = () => axios.get("/api/v1/tags");

const getCategories = () => axios.get("/api/v1/categories");

const publish = (id, params) => axios.put(`/api/v1/pages/${id}/publish`, params);

const discard = (id, params) => axios.put(`/api/v1/pages/${id}/discard`, params);

const toggleStatus = (id, params) => axios.put(`/api/v1/pages/${id}/toggle-status`, params);

const duplicate = (id) => axios.post(`/api/v1/pages/${id}/duplicate`);

// LF360-2016: what the article ids a scenario stores point at.
const referenceStates = (ids) => axios.post(`/api/v1/pages/reference-states`, { ids });

const importFile = (id, file) => {
  const fd = new FormData();
  fd.append("file", file, file.name);

  return axios.post(`/api/v1/pages/${id}/import`, fd);
};

const ApiArticles = {
  get,
  create,
  update,
  remove,
  removeBulk,
  getTags,
  fetchIcon,
  getCategories,
  publish,
  discard,
  toggleStatus,
  getById,
  duplicate,
  importFile,
  referenceStates,
};

export default ApiArticles;
